module.exports = __webpack_public_path__ + "static/media/upload.6c4ca441.png";